module.exports = __webpack_public_path__ + "static/media/money.35ff0b6c.jpg";